import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetches ALL entities from get-entities API for download purposes.
 * Uses a large pageSize to get everything in one call.
 *
 * @param {object} filters - optional filters { entityCategory, lobType, isVerified, etc. }
 * @returns {{ success: boolean, data: Array, error?: string }}
 */
export const fetchAllEntitiesForDownloadAction = async (filters = {}) => {
  try {
    const body = {
      id: null,
      category: filters.entityCategory || null,
      entityName: filters.entityName || null,
      email: filters.emailAddress || null,
      documentStatus: null,
      isVerified: filters.isVerified ?? null,
      entityLOBType: filters.lobType || null,
      startDate: null,
      endDate: null,
      pageNumber: 1,
      pageSize: 500,
    };

    const response = await apiClient.post(
      ATP_API_URL.GET_ALL_DATA_SEARCH,
      body,
    );

    if (response?.status === 200 && response.data) {
      const raw = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      return { success: true, data: raw };
    }

    return { success: false, data: [], error: "No data returned" };
  } catch (error) {
    return { success: false, data: [], error: error.message };
  }
};
